import { render, staticRenderFns } from "./SupervisorsDialog.vue?vue&type=template&id=cd13259a&scoped=true&"
import script from "./SupervisorsDialog.vue?vue&type=script&lang=js&"
export * from "./SupervisorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13259a",
  null
  
)

export default component.exports